import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  duration?: number;
}

/** Viewport-triggered fade + rise. Fires once, respects prefers-reduced-motion. */
export function Reveal({
  children,
  className,
  delay = 0,
  duration = 0.5
}: RevealProps) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className} data-id="element-243" data-mp="2jqygblz4csu5">{children}</div>;
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 15
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-244" data-mp="2jsj50uyr5hk3">
      {children}
    </motion.div>;
}